'use strict';
import appPackageInfo from '../../../package.json';

export const navVersion: string = appPackageInfo.version;
export const layerVersion: string = '4.5';
export const minimumSupportedVersion: string = '4.0';
